import { ReactElement, useEffect, useRef } from 'react';
import { handleSsoPopupCallback } from '@/me/util';

/**
 * The landing page for the SSO popup. It runs inside the popup only, forwards
 * the result to the window that opened it and renders nothing — the popup
 * closes itself once the handshake completes.
 */
export function SsoCallbackPage(): ReactElement {
    const handled = useRef(false);

    useEffect(() => {
        if (handled.current) {
            return;
        }
        handled.current = true;

        handleSsoPopupCallback().catch((error: unknown) => {
            // The opener surfaces the failure; there is no UI to show it on here.
            console.error('SSO callback error', error);
        });
    }, []);

    return <></>;
}
